const { CHANNEL_INTERFACE_TYPE, CHANNEL_INTERFACE_TEXT } = require('@/enums');
const { transformEnumToOptions } = require('@/tools');

module.exports = () => {
  return {
    type: {
      label: '媒体平台',
      type: 'select',
      props: {
        clearable: false,
      },
      options: transformEnumToOptions({ labels: CHANNEL_INTERFACE_TEXT, values: CHANNEL_INTERFACE_TYPE }),
      value: CHANNEL_INTERFACE_TYPE.JRTT,
    },
    advertiser_id: {
      label: '广告主ID',
      type: 'input',
      value: '',
    },
  };
};

